import { render, staticRenderFns } from "./LabelGroupSvg.vue?vue&type=template&id=017c0344&"
import script from "./LabelGroupSvg.vue?vue&type=script&lang=ts&"
export * from "./LabelGroupSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports